module.exports = __webpack_public_path__ + "static/media/equals.b15d38fa.svg";